export const useIsLogin = () => {
  if (localStorage.getItem('token')) return true
  else false
}
